import { render, staticRenderFns } from "./fdInventory50.vue?vue&type=template&id=06935c36"
import script from "./fdInventory50.vue?vue&type=script&lang=js"
export * from "./fdInventory50.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports